import React, { useEffect, useState } from 'react';
import api from '../services/api';
const s = {
  title:{ fontSize:22, fontWeight:600, color:'#f1f5f9', marginBottom:6 },
  sub:  { fontSize:13, color:'#64748b', marginBottom:24 },
  card: { background:'#1e293b', border:'1px solid #334155', borderRadius:12, padding:20 },
  table:{ width:'100%', borderCollapse:'collapse' },
  th:   { fontSize:11, color:'#475569', textAlign:'left', padding:'8px', borderBottom:'1px solid #334155', textTransform:'uppercase' },
  td:   { fontSize:13, color:'#cbd5e1', padding:'8px', borderBottom:'1px solid #1e293b' },
};
export default function Contatos() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get('/contatos').then(r => setRows(Array.isArray(r.data)?r.data:[])); }, []);
  return (
    <div>
      <div style={s.title}>Contatos</div>
      <div style={s.sub}>Contatos registrados no sistema — {rows.length} encontrados</div>
      <div style={s.card}>
        <table style={s.table}><thead><tr>
          <th style={s.th}>Ref</th><th style={s.th}>Detalhes</th><th style={s.th}>Data</th>
        </tr></thead>
        <tbody>{rows.slice(0,50).map((r,i)=>(
          <tr key={i}>
            <td style={s.td}>{(r.id||'').substring?.(0,8)}...</td>
            <td style={s.td}>{r.name||r.phone||r.descricao||r.tipo||r.status||''}</td>
            <td style={s.td}>{r.created_at?new Date(r.created_at).toLocaleDateString('pt-BR'):''}</td>
          </tr>
        ))}</tbody></table>
      </div>
    </div>
  );
}
